/**
 * Populate driver data for reservation
 * @param {*} driver - The driver object
 * @returns {Object} - The populated driver data
 */
export function populateDriver(driver) {
    if (!driver) return null;
    return {
        person: {
            first_name: driver.person.first_name,
            last_name: driver.person.last_name,
            full_name: driver.person.full_name,
            gender: driver.person.gender,
            numbre_phone: driver.person.numbre_phone
        },
        profile: {
            image: driver.profile.image
        },
        relationship: {
            branch: driver.relationship.branch,
            auto_assign: driver.relationship.auto_assign
        },
        account: {
            email: driver.account.email
        }
    };
}

/**
 * Populate service data for reservation
 * @param {Object} reservation - The reservation object
 * @param {Object} vehicle - The vehicle object
 * @returns {Object|null} - The populated service data or null if service is not provided
 */
export function populateService(reservation, vehicle) {
    let { service, pricing, supplier } = reservation;
    if (!service) return null;
    return {
        _id: service._id,
        vehicle: {
            _id: vehicle._id,
            seats: vehicle.parameters.n_seats,
            suitcases: vehicle.parameters.n_suitcases,
            type_service: vehicle.parameters.type_category,
            category: vehicle.parameters.category,
            make: vehicle.parameters.make,
            make_label: vehicle.parameters.name,
            image: vehicle.information.image,
            tags: vehicle.parameters.tags || [],
            isComposite: vehicle.parameters.isComposite
        },
        hours_advance: service.advancedReservation,
        preference: service.preference,
        currency: {
            code: service.currency_code,
            symbol: service.currency_symbol,
            label: service.currency_label
        },
        branchId: service.branch,
        supplierId: supplier ? supplier._id : null,
        base_price: pricing.net_price.last_amount,
        sale_price: pricing.sale_price.last_amount,
        basePriceComposition: pricing.base_price.composition,
        surcharges: reservation.surcharges,
        unit: supplier ? supplier.settings.measurementUnit : "km",
        distance_include: service.hours_disposition
            ? service.hours_disposition.km_include
            : 0,
        min_hours: service.hours_disposition
            ? service.hours_disposition.min_hours
            : 0,
        cancellationPolicy: service.cancellationPolicy
            ? service.cancellationPolicy.descriptions
            : [],
        keyDetails: service.keyDetails,
        termsConditions: service.termsConditions
    };
}